<template>
  <q-dialog :model-value="modelValue" persistent @update:model-value="$emit('update:modelValue', $event)">
    <q-card class="neg-escopo neg-modal neg-modal--largo">
      <q-card-section class="neg-modal__titulo">
        Baixa do repasse
        <div class="neg-sub">
          Marque o que veio neste pagamento do banco e informe o valor de cada proposta
        </div>
      </q-card-section>

      <q-card-section class="neg-modal__corpo">
        <negocios-campo-data
          label="Data do repasse"
          :clearable="false"
          :value="data"
          :error="Boolean(erroDaData)"
          :error-message="erroDaData"
          @input="data = $event"
        />

        <div v-for="linha in linhas" :key="linha.oportunidade_id" class="neg-baixa">
          <div class="neg-baixa__identificacao">
            <b>{{ linha.codigo }}</b>
            <div class="neg-sub">{{ linha.cliente }}</div>
            <div class="neg-sub">
              Previsto {{ formatarMoeda(linha.comissao_prevista) }} · Recebido
              {{ formatarMoeda(linha.comissao_recebida) }}
            </div>
          </div>

          <q-field v-model="linha.valor" dense stack-label label="Valor recebido">
            <template v-slot:control="{ id, floatingLabel, modelValue, emitValue }">
              <money-input
                :id="id"
                class="q-field__native text-right"
                :value="modelValue"
                v-bind="moneyFormat"
                v-show="floatingLabel"
                @input="emitValue"
              />
            </template>
          </q-field>

          <q-input v-model="linha.observacao" dense clearable label="Observação" />

          <q-toggle v-model="linha.estorno" label="Devolução" />
          <div v-if="linha.estorno" class="neg-sub">
            O banco cobrou de volta. Vai entrar como valor negativo.
          </div>
        </div>
      </q-card-section>

      <q-card-section class="neg-baixa__total">
        <span>Total do lote</span>
        <b :class="{ 'neg-negativo': total < 0 }">{{ formatarMoeda(total) }}</b>
      </q-card-section>

      <q-card-actions align="right">
        <q-btn flat no-caps label="Cancelar" @click="$emit('update:modelValue', false)" />
        <q-btn
          unelevated
          no-caps
          color="primary"
          label="Confirmar baixa"
          :loading="salvando"
          @click="confirmar"
        />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script>
import MoneyInput from "@/components/Utils/money-input.vue";
import negociosMixin from "@/mixins/negocios";

import moment from "moment";

export default {
  name: "negocios-modal-baixa",

  emits: ["update:modelValue", "registrou"],
  components: { MoneyInput },
  mixins: [negociosMixin],
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    itens: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      data: null,
      linhas: [],
      salvando: false,
      erroDaData: ""
    };
  },
  computed: {
    total() {
      return this.linhas.reduce((soma, linha) => soma + this.valorAssinado(linha), 0);
    }
  },
  watch: {
    modelValue(aberto) {
      if (!aberto) {
        return;
      }

      this.erroDaData = "";
      this.data = moment().format("YYYY-MM-DD");
      this.linhas = this.itens.map(item => ({
        oportunidade_id: item.oportunidade_id,
        codigo: item.codigo,
        cliente: item.cliente,
        comissao_prevista: Number(item.comissao_prevista || 0),
        comissao_recebida: Number(item.comissao_recebida || 0),
        valor: this.faltaReceber(item),
        observacao: null,
        estorno: false
      }));
    }
  },
  methods: {
    faltaReceber(item) {
      const falta = Number(item.comissao_prevista || 0) - Number(item.comissao_recebida || 0);

      return falta > 0 ? Number(falta.toFixed(2)) : 0;
    },
    valorAssinado(linha) {
      const valor = Number(linha.valor || 0);

      return linha.estorno ? -valor : valor;
    },
    confirmar() {
      if (!this.data) {
        this.erroDaData = "Informe a data do repasse";
        return;
      }

      this.salvando = true;

      const recebimentos = this.linhas.map(linha => ({
        oportunidade_id: linha.oportunidade_id,
        data: this.data,
        valor: this.valorAssinado(linha),
        observacao: linha.observacao
      }));

      this.$store.dispatch("registrarNegociosRecebimento", recebimentos).then(resposta => {
        this.salvando = false;

        this.avisar(resposta.message, resposta.success ? "green" : "orange");

        if (resposta.success) {
          this.$emit("registrou");
          this.$emit("update:modelValue", false);
        }
      });
    }
  }
};
</script>
